import React, { useEffect } from "react";
import HomePageComponent from "./components/HomePageComponent";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { getUser, logout } from "../../slices/authSlice";
import { useNavigate } from "react-router-dom";


const HomePage: React.FC = () => {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const basicUserInfo = useAppSelector((state) => state.auth.basicUserInfo);

  useEffect(() => {
    if (basicUserInfo == null) {
      handleLogout()
    }
    if (basicUserInfo) {
      dispatch(getUser(basicUserInfo.id));
    }
  }, [basicUserInfo]);

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap();
      navigate("/login");
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <HomePageComponent />
    </>
  );
};

export default HomePage;
